import { lazy } from 'react';

// Pages are code-split; each chunk loads on first navigation (Suspense fallback in the layout).
export const LoginPage = lazy(() =>
  import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage })),
);
export const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
export const UsersPage = lazy(() =>
  import('@/pages/UsersPage').then((m) => ({ default: m.UsersPage })),
);
export const RolesPage = lazy(() =>
  import('@/pages/RolesPage').then((m) => ({ default: m.RolesPage })),
);
export const AccountPage = lazy(() =>
  import('@/pages/AccountPage').then((m) => ({ default: m.AccountPage })),
);
export const DocumentsPage = lazy(() =>
  import('@/pages/DocumentsPage').then((m) => ({ default: m.DocumentsPage })),
);
export const DocumentUploadPage = lazy(() =>
  import('@/pages/DocumentUploadPage').then((m) => ({ default: m.DocumentUploadPage })),
);
export const DocumentReviewPage = lazy(() =>
  import('@/pages/DocumentReviewPage').then((m) => ({ default: m.DocumentReviewPage })),
);
export const ApiClientsPage = lazy(() =>
  import('@/pages/ApiClientsPage').then((m) => ({ default: m.ApiClientsPage })),
);
